/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Rulecount1Inputs */

const en_entity_rulecount1 = /** @type {(inputs: Entity_Rulecount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rule Count`)
};

const de_entity_rulecount1 = /** @type {(inputs: Entity_Rulecount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regelanzahl`)
};

/**
* | output |
* | --- |
* | "Rule Count" |
*
* @param {Entity_Rulecount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_rulecount1 = /** @type {((inputs?: Entity_Rulecount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Rulecount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_rulecount1(inputs)
	return de_entity_rulecount1(inputs)
});
export { entity_rulecount1 as "entity_ruleCount" }